import CancellableHelper from "@/requests/CancellableHelper";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { CreditCardStatementsResponse } from "@/models/api/finances/CreditCardStatementsListItem";
import { CreditCardStatementResponse } from "@/models/api/finances/CreditCardStatementListItem";
import { FileTmp } from "@/models/api/Files";
import { axiosInstance } from "@/plugins/axios";

//#region Routes
export const URL_GET_CREDIT_CARD_STATEMENTS = "/CreditCardStatements/GetCreditCardStatements/Paged";
export const URL_GET_CREDIT_CARD_STATEMENT =
  "/CreditCardStatements/GetCreditCardStatementItems/${CreditCardStatementId}/Paged";
export const URL_POST_UPLOAD_CREDIT_CARD_STATEMENT_FILE = "/File/UploadCreditCardStatementFile";
export const URL_POST_PARSE_CREDIT_CARD_STATEMENT = "/CreditCardStatements/ParseCreditCardStatements";
//#endregion

const _getCreditCardStatementsTable = new CancellableHelper<CreditCardStatementsResponse>(
  URL_GET_CREDIT_CARD_STATEMENTS,
  CreditCardStatementsResponse
);
_getCreditCardStatementsTable.jsonSerializer = true;
export const getCreditCardStatementsTable = async (
  genericTableRequest: GenericTableRequest
): Promise<CreditCardStatementsResponse> => {
  return await _getCreditCardStatementsTable.get(genericTableRequest);
};

const _getCreditCardStatement = new CancellableHelper<CreditCardStatementResponse>(
  URL_GET_CREDIT_CARD_STATEMENT,
  CreditCardStatementResponse
);
_getCreditCardStatement.jsonSerializer = true;
export const getCreditCardStatement = async (
  id: number,
  genericTableRequest: GenericTableRequest
): Promise<CreditCardStatementResponse> => {
  return await _getCreditCardStatement.get({
    ...genericTableRequest,
    ...{ CreditCardStatementId: id },
  });
};

export const postUploadCreditCardStatementFile = async (files: Array<File>): Promise<Array<FileTmp>> => {
  const formData = new FormData();
  for (const file of files) {
    formData.append(file.name, file);
  }
  const response = await axiosInstance.post(URL_POST_UPLOAD_CREDIT_CARD_STATEMENT_FILE, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data as Array<FileTmp>;
};

const _postParseCreditCardStatements = new CancellableHelper<null>(URL_POST_PARSE_CREDIT_CARD_STATEMENT, null, true);
export const postParseCreditCardStatements = async (tmpFileIdList: Array<number>, bankType: number): Promise<void> => {
  await _postParseCreditCardStatements.post({ TmpFileIdList: tmpFileIdList, BankType: bankType }, null);
};
